<template>
  <!-- 订单列表 -->
  <div class="orderList">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['订单管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" icon="el-icon-download" @click="exportData"
        v-if="buttonVisibility.export"
          >导出数据</el-button
        >
        <el-button type="danger" @click="handleDel()" v-if="buttonVisibility.delete">删除</el-button>
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">支付方式：</label>
        <el-select
          placeholder="支付方式"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.payment"
          clearable
        >
          <el-option label="全部" value=""> </el-option>
          <el-option
            v-for="(item, index) in payTypeData"
            :key="index"
            :label="item.PayType"
            :value="item.PayType"
          >
          </el-option>
          <!-- <el-option label="支付宝" value="支付宝"> </el-option>
          <el-option label="对公支付" value="对公支付"> </el-option> -->
        </el-select>
        <label class="label">订单类型：</label>
        <el-select
          placeholder="订单类型"
          style="width: 100px; margin-right: 10px"
          v-model="searchForm.orderType"
          clearable
        >
          <el-option label="普通" value="BDD"> </el-option>
          <el-option label="预售" value="BYS"> </el-option>
        </el-select>
        <label class="label">单据状态：</label>
        <el-select
          placeholder="单据状态"
          style="width: 100px; margin-right: 10px"
          v-model="searchForm.orderStatus"
          clearable
        >
          <el-option
            v-for="(item, index) in statusList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.start"
          style="width: 160px; margin-right: 10px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
          v-model="searchForm.end"
          style="width: 160px; margin-right: 10px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-input
          style="width: 160px; margin-right: 10px"
          clearable
          placeholder="输入订单号/客户名称"
          v-model="searchForm.name"
        >
        </el-input>
        <el-input
          style="width: 160px; margin-right: 10px"
          clearable
          placeholder="业务员姓名"
          v-model="searchForm.salemanName"
        ></el-input>
        <el-button type="primary" icon="el-icon-search" @click="seach" v-if="buttonVisibility.search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="selectionChangeTable"
    >
      <el-table-column type="selection" align="center" width="55">
      </el-table-column>
      <el-table-column
        label="序号"
        width="60"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="order_no"
        align="center"
        width="130"
        show-overflow-tooltip
        label="单据编号"
      >
      </el-table-column>
      <el-table-column
        prop="add_time"
        width="150"
        label="下单日期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="businesscode"
        label="用户编号"
        width="110"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="businessname"
        label="用户名称"
        width="150"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="PayType"
        label="支付方式"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="levelName1"
        label="省代"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="levelName2"
        label="市代"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="levelName3"
        label="业务员"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="levelName4"
        label="推广员"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="order_amount"
        label="总金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="payment_fee"
        label="已付金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="real_amount"
        label="应付金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="refund_fee"
        label="退款金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="discount_amount"
        label="优惠金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="status"
        label="订单状态"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="Source"
        label="来源"
        width="60"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="postage"
        label="邮费"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <!-- <el-table-column
        prop="username"
        label="客户编号"
        width="80"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column> -->
      <!-- <el-table-column
        prop="kpyName"
        label="开票员"
        align="center"
        width="90"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="salezMan"
        label="业务员"
        align="center"
        width="90"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="客户名称"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column> -->

      <!-- <el-table-column
        prop="DGvoucher"
        width="100"
        label="支付凭证"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.filePath"
            type="primary"
            plain
            style="padding: 2px 3px"
            @click="previewImg(scope)"
            >点击查看
          </el-button>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="create"
        label="操作"
        width="150"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click="addDetail(scope.row.order_no)"
            v-if="buttonVisibility.view"
            style="padding: 2px 3px"
            plain
            >查看
          </el-button>
          <el-button
            v-if="
              scope.row.PayType == '对公支付' && scope.row.status !== '待支付' && buttonVisibility.viewPayType
            "
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleAduit(scope)"
            >查看凭证
          </el-button>
          <!-- <el-button
            v-if="scope.row.status == '待支付'"
            type="danger"
            @click="delOrder(scope.row.order_no)"
            style="padding: 2px 3px"
            plain
            >删除</el-button
          > -->
          <!-- <el-button
            v-if="scope.row.Isrefund == 'Y'"
            type="danger"
            @click="retOrder(scope.row)"
            style="padding: 2px 3px"
            plain
            >退款</el-button
          > -->
          <!-- 状态大于等于5，已出库后显示 -->
          <!-- <el-button
            type="success"
            @click="qualityReport(scope)"
            style="padding: 2px 3px"
            plain
            >质检报告</el-button
          > -->
          <!-- 支付方式为对公支付，支付状态为未支付 -->
          <!-- <el-button
            v-if="
              scope.row.PayType == '对公支付' && scope.row.status == '待支付'
            "
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleAduit(scope)"
            >审核
          </el-button> -->

          <!-- 预售订单审核，如果是预售订单而且是未审核、已支付/待下发状态的订单 -->
          <el-button
            v-if="
              scope.row.IsAut == 'N' &&
              scope.row.OrderType == 'BYS' &&
              scope.row.OrderStatus == 2
              && buttonVisibility.YSAduit
            "
            type="warning"
            style="padding: 2px 3px"
            plain
            @click="handleYSAduit(scope)"
            >预售审核
          </el-button>
          <el-button
            v-if="scope.row.IsAut == 'Y' && scope.row.OrderType == 'BYS' && buttonVisibility.Aduited"
            type="success"
            style="padding: 2px 3px"
            plain
            >已审核
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <!-- 物流信息维护 -->
    <el-dialog
      title="对公支付凭证"
      :visible.sync="dialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="500px"
    >
      <el-form label-width="120px">
        <el-form-item label="对公支付凭证：">
          <el-image
            style="width: 200px; height: 200px"
            :src="documentPicture"
            fit="contain"
            :preview-src-list="[documentPicture]"
          >
            <div class="image-error-tip" slot="error">
              <span>客户暂未上传对公支付凭证</span>
            </div>
          </el-image>
        </el-form-item>
        <el-form-item
          label="备注："
          v-if="selectRow.PayType == '对公支付' && selectRow.status == '待支付'"
        >
          <el-input v-model="autRemark" style="width: 200px"></el-input>
        </el-form-item>
      </el-form>

      <span
        slot="footer"
        class="dialog-footer"
        v-if="selectRow.PayType == '对公支付' && selectRow.status == '待支付'"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="passTheAduit">审 核</el-button>
      </span>
    </el-dialog>

    <!-- 预售订单审核 -->
    <el-dialog
      title="预售订单审核"
      :visible.sync="ysDialogVisible"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="500px"
    >
      <el-form label-width="120px">
        <el-form-item label="备注：">
          <el-input v-model="YSAuditRemark" style="width: 200px"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="passYSorder('Q')">拒 审</el-button>
        <el-button type="primary" @click="passYSorder('Y')">审 核</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "orderList",
  data() {
    return {
      /**表格数据 */
      //序号	机构	单据编号	客户编号	客户名称	收货人
      // {
      //   organ:"机构",
      //   orderNum:"单据编号",
      //   customNum:"客户编号",
      //   customer:"客户名称",
      //   consignee:"收货人",
      //   payMode:"支付方式",
      //   orderStatus:"订单状态",
      //   coupon:"优惠金额",
      //   actualPayment:"实付金额",
      //   sum:"总金额",
      //   source:"来源",
      //   create:"下单日期"
      // }
      tableData: [],
      /**搜索表单 */
      //单据状态 开始日期 截止日期 模糊查询
      searchForm: {
        orderType: "BDD", //订单类型
        payment: "",
        orderStatus: "99",
        start: "",
        end: "",
        name: "",
        salemanName: "",
      },
      selectionTable: [],
      originalStatusList: [],
      statusList: [],

      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**对公支付 */
      documentPicture: "",
      dialogVisible: false,
      autRemark: "", //审核备注
      selectRow: {}, //需要审核的订单数据

      /**预售订单审核 */
      ysDialogVisible: false,
      YSAuditRemark: "", //预售订单审核

      // 获取支付方式
      payTypeData: [],
    };
  },
  computed: {
    ...mapState(['buttonPermissions']),
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['订单列表'] || [] 
      // console.log('buttonsLimit', buttonsLimit);
      return {
        export: buttonsLimit.includes('导出数据'),
        delete: buttonsLimit.includes('删除'),
        search: buttonsLimit.includes('搜索'),
        view: buttonsLimit.includes('查看'),
        viewPayType: buttonsLimit.includes('查看凭证'),
        YSAduit: buttonsLimit.includes('预售审核'),
        Aduited: buttonsLimit.includes('已审核'),
      }
    }
  },
  mounted() {
    const originalStatusList = this.$store.state.ORDER_STATUS; //订单状态
    this.statusList = originalStatusList.map(item => {
    // 修正已发货的映射
    if (item.label === '已发货') {
      return { ...item, value: '6' }; // 强制改为6
    }
    // 修正已收货的映射
    if (item.label === '已完成') {
      return { ...item, value: '7' }; // 强制改为7
    }
    return item;
    });
    // console.log('this.statusList',this.statusList);
    this.searchForm.start = this.$theMonthFirstDay(); // 默认查询本月的，查询太多了会卡
    this.getTableData();
    this.getpayType();
  },
  activated() {
    // 从缓存中获取是否存在订单查询条件(从首页传来)
    let keyword = window.sessionStorage.getItem("keyword");
    // console.log('keyword', keyword);

    if (keyword) {
      window.sessionStorage.removeItem("keyword");
      if (this.statusList && this.statusList.length > 0) {
        const trimmedKeyword = keyword.trim();
        const statusMapping = {
        '待付款': '1',
        '已审核': '2',
        '待处理': '3',
        '已出库': '4',
        '已发货': '6',
        '已完成': '7',
        '已退货': '10',
        '已退款': '11',
        };
        // 使用映射关系查找
        if (statusMapping[trimmedKeyword]) {
          this.searchForm.orderStatus = statusMapping[trimmedKeyword];
        } else {
          this.searchForm.orderStatus = "99";
        }

        // 立即执行搜索
        this.$nextTick(() => {
          this.getTableData(1);
        });
      }

      // 状态转换
      // let arr = [
      //   {
      //     value: "1",
      //     label: "待付款",
      //   },
      //   {
      //     value: "2",
      //     // label: "待下发",
      //     label: "已审核",
      //   },
      //   {
      //     value: "3",
      //     // label: "待出库",
      //     label: "待处理",
      //   },
      //   {
      //     value: "4",
      //     label: "已出库",
      //   },
      //   {
      //     value: "5",
      //     label: "已发货",
      //   },
      //   {
      //     value: "6",
      //     label: "待退款",
      //   },
      // ];

      // for (let i = 0; i < arr.length; i++) {
      //   console.log('i',i);
      //   if (arr[i].label == keyword) {
      //     this.searchForm.orderStatus = arr[i].value;
      //     break;
      //   }
      // }

      //延时触发
      let timer = setTimeout(() => {
        this.getTableData();
        clearTimeout(timer);
        timer = null;
      }, 300);
    }
  },
  methods: {
    seach() {
      this.getTableData(1);
    },

    getpayType() {
      let data = {
        entId: localStorage.getItem("entId"),
      };
      this.$request({
        url: "Base/GetEntPayTypeList",
        method: "post",
        data: data,
      }).then((res) => {
        this.payTypeData = [];
        if (res.success) {
          let payTypeData = res.list.filter((item) => item.IsRecharge !== "Y");
          this.payTypeData = payTypeData;
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "GetOrderList",
        orderType: this.searchForm.orderType,
        payment: this.searchForm.payment,
        status: this.searchForm.orderStatus,
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        strWhere: this.searchForm.name,
        ywy: this.searchForm.salemanName,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Proc_Admin_Order"; // 存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "order/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = 0;
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 文字格式化状态
    formatStatus(status) {
      const statusMap = {
        '0': '全部',
        '1': '待付款', 
        '2': '已审核', 
        '3': '待处理',
        '4': '已出库', 
        // '5': '发货中',
        '6': '已发货', 
        '7': '已完成', 
        // '7': '已删除', 
      };
    return statusMap[status] || status;
    },
    // 订单详情查看
    addDetail(id) {
      let prams = encodeURIComponent(
        JSON.stringify({
          id: id,
        })
      );
      this.$router.push({
        path: "orderInfo",
        query: {
          row: prams,
        },
      });
    },
    selectionChangeTable(section) {
      this.selectionTable = section;
    },
    /**删除 */
    handleDel() {
      if (this.selectionTable.length == 1) {
        let row = this.selectionTable[0];
        if (row.status == "待支付") {
          this.delOrder(row.order_no);
        } else {
          this.$message({
            message: "订单状态只有待支付才能删除",
            type: "warning",
          });
        }
      } else {
        this.$message({
          message: "只能删除一条数据",
          type: "warning",
        });
      }
    },
    // 未支付订单删除
    delOrder(id) {
      this.$confirm("确定要删除订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            orderNo: id,
          };
          this.$request({
            url: "Order/DltOrder",
            method: "post",
            data: data,
          })
            .then((res) => {
              if (res.success) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },
    // 订单退款
    retOrder(row) {
      let prams = encodeURIComponent(
        JSON.stringify({
          id: row.order_no,
          payPrice: row.payment_fee,
          refPrice: row.refund_fee,
          postage: row.postage,
        })
      );
      this.$router.push({
        path: "orderRefund",
        query: {
          row: prams,
        },
      });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    // 导出数据
    exportData() {
      let data = {
        type: "GetOrderList",
        userId: window.localStorage.getItem("userId"),
        entId: window.localStorage.getItem("entId"),
        orderType: this.searchForm.orderType,
        status: this.searchForm.orderStatus,
        startDate: this.searchForm.start,
        endDate: this.searchForm.end,
        strWhere: this.searchForm.name,
        ywy: this.searchForm.salemanName,
        PageIndex: 1,
        PageSize: 1048576, //Excel 2013版，最大行数
      };
      let proc = "Proc_Admin_Order";
      window.location.href =
        this.baseUrl +
        "Order/NoPIGExprot?json=" +
        encodeURIComponent(JSON.stringify(data)) +
        "&proc=" +
        encodeURIComponent(proc) +
        "&name=订单列表";

      // 下面这个操作可文档导出数据，洛奥的修改为一次性导出
      // if (this.allPage <= 1000) {
      //   window.location.href =
      //     this.baseUrl +
      //     "Order/NoPIGExprot?json=" +
      //     encodeURIComponent(JSON.stringify(data)) +
      //     "&proc=" +
      //     encodeURIComponent(proc) +
      //     "&name=订单列表";
      // } else {
      //   data.PageSize = 1000;
      //   let len = Math.floor(this.allPage / data.PageSize);
      //   len = this.allPage % data.PageSize > 0 ? len + 1 : len;
      //   for (let i = 1; i <= len; i++) {
      //     setTimeout(() => {
      //       data.PageIndex = i;
      //       const iframe = document.createElement("iframe");
      //       iframe.style.display = "none"; // 防止影响页面
      //       iframe.style.height = 0; // 防止影响页面
      //       iframe.src =
      //         this.baseUrl +
      //         "Order/NoPIGExprot?json=" +
      //         encodeURIComponent(JSON.stringify(data)) +
      //         "&proc=" +
      //         encodeURIComponent(proc) +
      //         "&name=订单列表";
      //       document.body.appendChild(iframe);
      //       // iframe.remove();//删除所选元素
      //     }, i * 50);
      //   }
      // }
    },

    /**点击审核按钮 */
    handleAduit({ row }) {
      this.dialogVisible = true;
      this.documentPicture = row.filePath;
      this.selectRow = row;
      console.log(row, "23232");
    },

    /**支付凭证审核通过 */
    passTheAduit() {
      this.$confirm("确定要审核订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            orderNo: this.selectRow.order_no,
            autRemark: this.autRemark,
          };
          this.$request({
            url: "/Order/AuditOrderStatus",
            method: "post",
            data,
          })
            .then((res) => {
              let type = "success";
              if (res.success) {
                this.getTableData(this.currPage);
                this.dialogVisible = true;
              } else {
                type = "error";
              }
              this.$message({
                message: res.message,
                type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch(() => {});
    },

    /**点击预售审核 */
    handleYSAduit({ row }) {
      this.ysDialogVisible = true;
      this.selectRow = row;
      console.log(this.selectRow);
    },
    /**支付凭证审核通过 */
    passTheSuccess() {
      let data = {
        // userId: getStorage("userId"),
        // entid: getStorage("entId"),
        orderNo: this.selectRow.order_no,
        realAmount: this.selectRow.real_amount,
      };
      this.$request({
        url: "/Order/CouponGive",
        method: "post",
        data,
      })
        .then((res) => {
          let type = "success";
          this.$message({
            message: res.message,
            type,
          });
        })
        .catch((err) => {
          window.console.log(err);
        });
    },

    /**预售订单通过 */
    passYSorder(status) {
      console.log();
      this.$confirm("确定要审核订单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = {
            ids: [this.selectRow.order_no],
            status: status,
            message: this.YSAuditRemark,
          };
          this.$request({
            url: "/OrderAdmin/AutPreSaleOrder",
            method: "post",
            data,
          })
            .then((res) => {
              let type = "success";
              if (res.success) {
                this.getTableData(this.currPage);
                // if (status == "Y") {
                //   this.passTheSuccess(this.selectRow);
                // }
                this.ysDialogVisible = false;
              } else {
                type = "error";
              }
              this.$message({
                message: res.message,
                type,
              });
            })
            .catch((err) => {
              window.console.log(err);
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>

<style scoped>
.orderList {
  width: 100%;
  height: 100%;
}
</style>

<style lang="scss">
/**对公支付审核未上传凭证提示 */
// 插槽中的类也会被样式隔离限制
.image-error-tip {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
}
</style>
